import {updateMailingListsSignUpFormsCount} from '@Components/email-marketing-campaign-audience/email-marketing-campaign-audience-reducer';
import {getMailingListsSignUpFormCount} from '@Libraries/email-marketing-campaigns-audience-library';
import {useAppDispatch, useAppSelector} from '@/hooks';

type UseMailingListAndSignupFormsType = {
  isMailingListSignUpFormLoading: boolean;
  isMailingListRenderComplete: boolean;
  isSignUpFormRenderComplete: boolean;
  mailingListCount: number;
  signUpFormCount: number;
  fetchMailingListSignupFormCounts: () => Promise<void>;
};

export interface MailingListsSignUpFormCountResponse {
  mailingListCount: number;
  signUpFormCount: number;
}

const useMailingListAndSignupForms = (): UseMailingListAndSignupFormsType => {
  const dispatch = useAppDispatch();
  const isMailingListSignUpFormLoading = useAppSelector((state) => {
    return state.emailMarketingCampaignAudience.isMailingListSignUpFormLoading;
  });

  const updateMailingListsSignUpFormsCountState = (mailingListSignUpFormsCountObject: MailingListsSignUpFormCountResponse): void => {
    dispatch(updateMailingListsSignUpFormsCount(mailingListSignUpFormsCountObject));
  };

  const isMailingListRenderComplete = useAppSelector((state) => {
    return state.emailMarketingCampaignAudience.isMailingListRenderComplete;
  });

  const isSignUpFormRenderComplete = useAppSelector((state) => {
    return state.emailMarketingCampaignAudience.isSignUpFormRenderComplete;
  });

  const mailingListCount = useAppSelector((state) => {
    return state.emailMarketingCampaignAudience.mailingListCount;
  });

  const signUpFormCount = useAppSelector((state) => {
    return state.emailMarketingCampaignAudience.signUpFormCount;
  });

  const fetchMailingListSignupFormCounts = async (): Promise<void> => {
    try {
      const countObject: MailingListsSignUpFormCountResponse = await getMailingListsSignUpFormCount();
      updateMailingListsSignUpFormsCountState(countObject);
    } catch (error) {
      console.error(error);
    }
  };

  return {
    isMailingListSignUpFormLoading,
    isMailingListRenderComplete,
    isSignUpFormRenderComplete,
    fetchMailingListSignupFormCounts,
    mailingListCount,
    signUpFormCount,
  };
};

export default useMailingListAndSignupForms;
